"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var EmailFilled = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M4.01688277,6.81604977 L10.6984173,12.5428965 L10.8341429,12.6495234 C11.5298106,13.1493367 12.4701894,13.1493367 13.1658571,12.6495234 L13.3015827,12.5428965 L19.9833015,6.81704371 C19.9942681,6.87635901 20,6.93751013 20,7 L20,17 C20,17.5522847 19.5522847,18 19,18 L5,18 C4.44771525,18 4,17.5522847 4,17 L4,7 C4,6.93716103 4.00579607,6.8756758 4.01688277,6.81604977 Z M19,6 C19.1165204,6 19.2283862,6.01992873 19.3323748,6.05656368 L12.6507914,11.7836399 L12.5536644,11.8572004 C12.2222606,12.0778819 11.7898331,12.0800887 11.4564089,11.8638209 L11.3492086,11.7836399 L4.66762515,6.05656368 C4.77161382,6.01992873 4.88347961,6 5,6 L19,6 Z" })));
};
EmailFilled.displayName = 'EmailFilled';
exports.default = EmailFilled;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=EmailFilled.js.map